import SvgEarth from 'assets/secure-financing/source-earth-icon.inline.svg';
import SourceLink from 'components/pages/financing-for-companies/items/SourceLink';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import React from 'react';

export default function SourcesBox() {
	const { t } = useTranslation();

	return (
		<div style={{ maxWidth: '80rem' }} className='border-2 border-grey-E rounded-10 sm:mt-20 xl:mx-auto bg-light'>
			<div className='sm:flex items-center py-15 px-10 sm:px-20'>
				<SvgEarth />

				<div className='sm:ml-15 mt-15 sm:mt-0'>
					<div className='flex items-center mb-12 sm:mb-07'>
						<SourceLink to='https://isap.sejm.gov.pl/isap.nsf/DocDetails.xsp?id=WDU19640160093'>
							{t('pageFinancingForCompany.sources.1')}
						</SourceLink>
					</div>
					<div className='flex items-center mb-12 sm:mb-07'>
						<SourceLink to='https://isap.sejm.gov.pl/isap.nsf/DocDetails.xsp?id=WDU19941210591'>
							{t('pageFinancingForCompany.sources.2')}
						</SourceLink>
					</div>
					<div className='flex items-center mb-12 sm:mb-07'>
						<SourceLink to='https://isap.sejm.gov.pl/isap.nsf/DocDetails.xsp?id=wdu19971400939'>
							{t('pageFinancingForCompany.sources.3')}
						</SourceLink>
					</div>
					<div className='flex items-center'>
						<SourceLink to='https://isap.sejm.gov.pl/isap.nsf/DocDetails.xsp?id=WDU20150001844'>
							{t('pageFinancingForCompany.sources.4')}
						</SourceLink>
					</div>
				</div>
			</div>
		</div>
	);
}
